module.exports = __webpack_public_path__ + "img/gshlogo.ca8d5d83.png";